<template>
<div class="Garden">
    <!-- <keep-alive include='reportList'> -->
        <router-view></router-view>        
    <!-- </keep-alive> -->
</div>
</template>

<script>
export default {
    name: 'Garden',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.Garden {
}
</style>